export default function PartnerIntroSection() {
  const benefits = [
    {
      icon: 'ri-truck-line',
      title: 'Consolidated Logistics',
      desc: 'Single-point delivery and stock management — we handle the complexity so you can focus on production.',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Financial Efficiency',
      desc: 'Managed receivables and demand bundling that reduce your administrative burden and improve cash flow.',
    },
    {
      icon: 'ri-global-line',
      title: 'Professional Representation',
      desc: 'Bilingual communication and 24/7 time-zone responsiveness — the professional bridge your clients expect.',
    },
  ];

  return (
    <section className="w-full px-6 md:px-16 py-16 bg-white border-b border-stone-100">
      <div className="max-w-5xl mx-auto">
        {/* Top label + heading */}
        <div className="mb-4">
          <span className="text-emerald-700 text-xs font-bold uppercase tracking-widest block mb-3">
            Partner With Us
          </span>
          <h2
            className="text-3xl md:text-4xl font-extrabold text-stone-900 leading-tight mb-5"
            style={{ fontFamily: "'DM Serif Display', serif" }}
          >
            Streamline Your Path to Market
          </h2>
        </div>

        {/* Intro paragraph */}
        <p className="text-stone-600 text-base leading-relaxed max-w-3xl mb-12">
          Whether you&apos;re looking to penetrate new territories or optimize existing client management,
          <strong className="text-stone-800"> MAX-Sourcing is your strategic partner.</strong> We offer
          end-to-end support that removes friction from your supply chain and puts your products in front
          of the right buyers — efficiently and professionally.
        </p>

        {/* Benefit cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {benefits.map(({ icon, title, desc }) => (
            <div
              key={title}
              className="rounded-lg border border-stone-100 bg-stone-50 p-6 flex flex-col gap-4"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-emerald-100">
                <i className={`${icon} text-emerald-700 text-xl`} />
              </div>
              <div>
                <h4 className="text-sm font-bold text-stone-900 mb-1">{title}</h4>
                <p className="text-xs text-stone-500 leading-relaxed">{desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA strip */}
        <div className="rounded-lg bg-emerald-700 px-8 py-7 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5">
          <div>
            <p className="text-white font-bold text-base leading-snug mb-1">
              Ready to add value to your supply chain?
            </p>
            <p className="text-emerald-100 text-sm leading-relaxed max-w-xl">
              Reach out today to see how we can provide the professional bridge and responsiveness your clients expect.
            </p>
          </div>
          <a
            href="#supplier-application-form"
            className="whitespace-nowrap bg-white text-emerald-800 text-sm font-bold px-7 py-3 rounded-md hover:bg-emerald-50 transition-colors cursor-pointer"
          >
            Apply Now
          </a>
        </div>
      </div>
    </section>
  );
}